<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Agenda',
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Agenda.vue